/**
 * A utility for handling animations with Intersection Observer
 * This helps ensure animations trigger when elements enter the viewport
 */

export const setupAnimationObservers = () => {
  // Ensure we're in the browser environment
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  // Immediately make all animation elements visible to ensure content accessibility
  document.querySelectorAll('.fade-in-up, .stagger-fade-in').forEach(el => {
    el.classList.add('visible');
    // Also add no-js class to ensure children are visible
    if (el.classList.contains('stagger-fade-in')) {
      el.classList.add('no-js');
    }
  });

  // Create intersection observer for fade-in-up animations
  const fadeObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Once animation is triggered, no need to observe anymore
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { 
    threshold: 0.15, // Trigger when 15% of the element is visible
    rootMargin: '0px 0px -50px 0px' // Slight negative margin to trigger sooner
  });

  // Observe all fade-in-up elements
  document.querySelectorAll('.fade-in-up').forEach(el => {
    fadeObserver.observe(el);
  });

  // Create intersection observer for staggered animations
  const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Remove no-js class to allow staggered animation to work
        if (entry.target.classList.contains('no-js')) {
          entry.target.classList.remove('no-js');
        }
        entry.target.classList.add('visible');
        // Once animation is triggered, no need to observe anymore
        staggerObserver.unobserve(entry.target);
      }
    });
  }, { 
    threshold: 0.1, // Trigger when 10% of the element is visible
    rootMargin: '0px 0px -75px 0px' // Negative margin to trigger sooner
  });

  // Observe all stagger-fade-in elements
  document.querySelectorAll('.stagger-fade-in').forEach(el => {
    staggerObserver.observe(el);
  });
};

// Function to handle manual animation triggering
export const triggerAnimation = (elementClass) => {
  // Add 'visible' class to trigger the animation
  document.querySelectorAll(elementClass).forEach(el => {
    el.classList.add('visible');
    // Also remove no-js class if present
    if (el.classList.contains('no-js')) {
      el.classList.remove('no-js');
    }
  });
}; 